import React, { Suspense } from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter as Router } from 'react-router-dom'
import { Provider } from 'react-redux'
import 'sanitize.css'
import { FirebaseAppProvider } from 'reactfire'
import * as Sentry from '@sentry/react'

import { App } from './components/App'
import * as serviceWorker from './serviceWorker'
import { store } from './store/index'
import { firebaseConfig } from './constants/firebase'
import { LoadingScreen } from './components/Loading'
import config from './config'

import GlobalStyles from 'src/styles/global'

Sentry.init({ dsn: config.SENTRY_DSN })

ReactDOM.render(
  <Provider store={store}>
    <FirebaseAppProvider firebaseConfig={firebaseConfig}>
      <GlobalStyles />
      <Suspense fallback={<LoadingScreen />}>
        <Router>
          <App />
        </Router>
      </Suspense>
    </FirebaseAppProvider>
  </Provider>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://facebook.github.io/create-react-app/docs/making-a-progressive-web-app
serviceWorker.unregister()
